import React from "react";
import {TableRowColumn} from 'material-ui/Table';
import FontIcon from "material-ui/FontIcon";
import {Tooltip} from 'react-tippy';

const InventoryCell = ({name, rateType, showRate, bookable}) => {

  const styles = {
    customStyle: {
      textOverflow: 'clip',
      whiteSpace: 'pre-wrap',
      paddingRight: 0,
      width: 150,
    },
    iconStyle: {
      fontSize: 24
    }
  };

  return (
      <TableRowColumn className="roomType" style={styles.customStyle}>
        <div className="roomTypeContainer">
          <div className="roomTypeName">
            {name}
          </div>
          {showRate && bookable && <Tooltip trigger="mouseenter"
                   size='small'
                   arrow={true}
                   theme='dark'
                   position='right'
                   interactive
                   html={
                     rateType === 'P' ?
                         <p>Rate displayed is for 2 people</p> :
                         <p>Rate displayed is for 1 room</p>}
                   >
          <div className="rateTypeIcon">
            {rateType === 'P' ? <FontIcon style={styles.iconStyle}
                                          className="material-icons">people</FontIcon>
                : <FontIcon style={styles.iconStyle}
                            className="material-icons">hotel</FontIcon>}
          </div>
          </Tooltip> }
        </div>
      </TableRowColumn>
  );

};

export default InventoryCell;


// WEBPACK FOOTER //
// ./src/components/InventoryCell.js